export const initialDetails = [
  { key: 'price', label: 'Price', icon: 'selly', value: '' },
  { key: 'surface', label: 'surface', icon: 'border_style', value: '' },
  { key: 'type', label: 'type', value: '', icon: 'apartment' },
  { key: 'bathroom', label: 'bathroom', value: '', icon: 'bathtub' },
  { key: 'rooms', label: 'rooms', value: '', icon: 'bed' },
  { key: 'toilette', label: 'toilette', value: '', icon: 'supervisor_account' },
  { key: 'funcionalUnit', label: 'funtional Unit', icon: '', value: '' },
  // {key:'available', label:'available', icon:'', value:''},
  { key: 'buildingAddress', label: 'building Address', icon: 'location_on', value: '' },
  { key: 'buildingState', label: 'building State', icon: '', value: '' },
  { key: 'buildingAge', label: 'building Age', icon: '', value: '' },
  { key: 'buildingAmenities', label: 'building Amenities', icon: '', value: '' },
  { key: 'zipCodeAreaCode', label: 'zipCode', icon: 'markunread_mailbox', value: '' },
  { key: 'countyName', label: 'County', icon: 'flag', value: '' },
  { key: 'stateName', label: 'state', icon: '', value: '' },
  { key: 'statePostalAbbr', label: 'Postal Abbr', icon: '', value: '' },
  { key: 'stateRank', label: 'state Rank', icon: 'show_chart', value: '' },
  { key: 'stateFips', label: 'state Fips', icon: '', value: '' },
  { key: 'stateTaxRate', label: 'state TaxRate', icon: '', value: '' },
  { key: 'stateAvgHomePrice', label: 'state Avg Home Price', icon: 'attach_mone', value: '' },
  { key: 'stateAvgPropertyTax', label: 'state Avg Property Tax', icon: 'attach_mone', value: '' },
  { key: 'stateHighestMetroArea', label: 'state Highest Metro Area', icon: '', value: '' },
  { key: 'stateHighestMetroTax', label: 'state Highest Metro Tax', icon: '', value: '' },
  { key: 'stateSingleFamilyHomes', label: 'state Single Family Homes', icon: 'group_add', value: '' },
  { key: 'statePropTaxes', label: 'state Prop Taxes', icon: '', value: '' },
  { key: 'stateRealEstateValue', label: 'state Real Estate Value', icon: '', value: '' }
]
